module.exports = __webpack_public_path__ + "img/medal-point-red.c3d8befe.svg";